<div class="assessment">
	<formio-loader></formio-loader>

	<!--
        <ng-container [ngTemplateOutlet]="overallAchievement"></ng-container>
    <br /> -->
	<div class="row">
		<app-category-card
			class="col-sm-4 mb-4"
			*ngFor="let item of categories"
			[category]="item"
			[customOptions]="customOptions"
			[processConfig]="processConfig"
			[data]="data"
			(onOpenCategory)="openCategory(item)"
			(onOpenSubCategory)="openSubCategory($event)"
		></app-category-card>
	</div>
</div>
<!--
<ng-template #overallAchievement>
	<div class="row">
		<div class="col-sm-8">
			<div class="card">
				<div class="header">{{ 'forms.common.overall achievement' | translate }}</div>
				<div class="content" id="chart" (resized)="onResized($event)">
					<p-chart type="polarArea" [data]="chartData"></p-chart>
				</div>
			</div>
		</div>
		<div class="col-sm-4">
			<div class="card">
				<div class="header">{{ 'forms.common.achievement by category' | translate }}</div>
				<div class="content" id="bars">
					<div class="bar-container" *ngFor="let item of categories; let last = last">
						<label>{{ item.name }}</label>
						<p-progressBar value="{{ item.percentage }}" id="bar_{{ item._id }}"></p-progressBar>
						<hr *ngIf="!last" />
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
 -->